module.exports = __webpack_public_path__ + "f72c6686d0e1fb91c11279f68417b539.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/adelle_bold-webfont.woff
// module id = 226
// module chunks = 0